export function getInitials(userName: string) {
	const splitedName = userName.split(' ');

	const firstLetter = splitedName[0][0];
	const secondLetter = splitedName.length > 1 ? splitedName[1][0] : '';

	return `${firstLetter}${secondLetter}`;
}
